import React from 'react';
import { Box, Button, Flex, Icon, Link, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { brand, whatsappHref } from '../data/brand';
const channels = [{
  icon: WhatsAppIcon,
  label: 'WhatsApp',
  value: brand.whatsapp,
  href: whatsappHref(),
  external: true
}, {
  icon: PhoneIcon,
  label: 'Teléfono',
  value: brand.phone,
  href: brand.phoneHref,
  external: false
}, {
  icon: MailIcon,
  label: 'Correo',
  value: brand.email,
  href: brand.emailHref,
  external: false
}, {
  icon: MapPinIcon,
  label: 'Ubicación',
  value: 'Miami, Florida',
  href: undefined,
  external: false
}];
export function Contact() {
  return <Box as="section" id="contacto" bg="ink.900" position="relative" overflow="hidden" pt={{
    base: 16,
    md: 28
  }} pb={{
    base: 16,
    md: 24
  }} mt={{
    md: '-4vw'
  }} sx={{
    clipPath: {
      base: 'none',
      md: 'polygon(0 0, 100% 4vw, 100% 100%, 0 100%)'
    }
  }} data-id="element-37" data-mp="ghw0hvioiexj">
      {/* Animated smoke layers (CSS only) */}
      <Box position="absolute" inset="-15%" pointerEvents="none" aria-hidden="true" bg="radial-gradient(38% 42% at 25% 35%, rgba(196,18,48,0.28) 0%, rgba(13,13,13,0) 70%), radial-gradient(30% 30% at 70% 20%, rgba(242,183,5,0.14) 0%, rgba(13,13,13,0) 70%)" animation="smokeDriftA 26s ease-in-out infinite" data-id="element-38" data-mp="3b3sualifo9n5" />
      <Box position="absolute" inset="-15%" pointerEvents="none" aria-hidden="true" bg="radial-gradient(34% 36% at 78% 72%, rgba(196,18,48,0.22) 0%, rgba(13,13,13,0) 70%), radial-gradient(28% 28% at 18% 85%, rgba(242,183,5,0.12) 0%, rgba(13,13,13,0) 70%)" animation="smokeDriftB 34s ease-in-out infinite" data-id="element-39" data-mp="3623fcus3bbts" />

      <Box px={{
      base: 5,
      md: 10,
      xl: 16
    }} position="relative" data-id="element-40" data-mp="udm1j7laf4yv">
        <Reveal data-id="element-41" data-mp="23bc3z55v2k01">
          <SectionHeading eyebrow="Estamos para escucharte" title="Consulta con nosotros" description="Comunícate con nuestro equipo para conocer nuestros servicios y resolver tus preguntas." tone="dark" data-id="element-42" data-mp="23bu78lqxxyhg" />
        </Reveal>

        <SimpleGrid columns={{
        base: 1,
        sm: 2,
        lg: 4
      }} spacing={{
        base: 4,
        md: 5
      }} mt={{
        base: 10,
        md: 16
      }} maxW="72rem" mx="auto" data-id="element-43" data-mp="1pc2o66lkhrwl">
          {channels.map((channel, index) => {
          const card = <VStack align="flex-start" spacing={4} h="100%" px={6} py={7} bg="rgba(250,243,232,0.06)" backdropFilter="blur(14px)" border="1px solid" borderColor="rgba(250,243,232,0.16)" boxShadow="0 18px 44px rgba(0,0,0,0.35)" transition="all 0.3s ease" _hover={channel.href ? {
            borderColor: 'rgba(242,183,5,0.6)',
            transform: 'translateY(-4px)',
            bg: 'rgba(250,243,232,0.1)'
          } : undefined} sx={{
            clipPath: 'polygon(0 0, 100% 0, 100% 86%, 88% 100%, 0 100%)'
          }} data-id="element-44" data-mp="2i2kxvqgsqriz">
                <Flex align="center" justify="center" w="2.75rem" h="2.75rem" borderRadius="full" bg="rgba(196,18,48,0.9)" color="cream.50" data-id="element-45" data-mp="3r8bk6cwvfl2f">
                  <Icon as={channel.icon} boxSize="1.15rem" aria-hidden="true" data-id="element-46" data-mp="9t4qaubap0vd" />
                </Flex>
                <Box minW={0} data-id="element-47" data-mp="dv84hqpcmjkc">
                  <Text fontSize="0.68rem" letterSpacing="0.24em" textTransform="uppercase" color="gold.400" mb={1} data-id="element-48" data-mp="dw1auqkeb71y">
                    {channel.label}
                  </Text>
                  <Text fontSize={{
                base: 'sm',
                md: 'md'
              }} color="cream.50" wordBreak="break-word" data-id="element-49" data-mp="14plycbrbc4o">
                    {channel.value}
                  </Text>
                </Box>
              </VStack>;
          return <Reveal key={channel.label} delay={index * 0.06} data-id="element-50" data-mp="3idck2v90bz2r" data-mpi={index}>
                {channel.href ? <Link href={channel.href} isExternal={channel.external} display="block" h="100%" _hover={{
              textDecoration: 'none'
            }} data-id="element-51" data-mp="3ec0u2om81bu1">
                    {card}
                  </Link> : card}
              </Reveal>;
        })}
        </SimpleGrid>

        <VStack spacing={5} mt={{
        base: 12,
        md: 16
      }} data-id="element-52" data-mp="12l5bg0uxseed">
          <Stack direction={{
          base: 'column',
          sm: 'row'
        }} spacing={3} w={{
          base: '100%',
          sm: 'auto'
        }} data-id="element-53" data-mp="2kjtioixrw4z6">
            <Button as="a" href={whatsappHref()} target="_blank" rel="noopener noreferrer" variant="whatsapp" h={{
            base: '3.5rem',
            md: '3.85rem'
          }} px={8} fontSize={{
            base: 'sm',
            md: 'md'
          }} leftIcon={<WhatsAppIcon size={21} data-id="element-55" data-mp="348m2j1erqdpw" />} data-id="element-54" data-mp="2pjpp0oty08hw">
              ESCRIBIR POR WHATSAPP
            </Button>
            <Button as="a" href={brand.phoneHref} variant="gold" h={{
            base: '3.5rem',
            md: '3.85rem'
          }} px={8} fontSize={{
            base: 'sm',
            md: 'md'
          }} leftIcon={<PhoneIcon size={18} aria-hidden="true" data-id="element-57" data-mp="3n652zgn5uo0p" />} data-id="element-56" data-mp="38bidc5y2h5ja">
              LLAMAR AHORA · {brand.phone}
            </Button>
          </Stack>
          <Text fontSize="sm" color="cream.200" opacity={0.7} textAlign="center" data-id="element-58" data-mp="3rypxylhsz75t">
            Atendemos consultas de personas mayores de 18 años.
          </Text>
        </VStack>
      </Box>
    </Box>;
}